import React from 'react';

export default function Phone() {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#a)'>
        <path
          d='m7.385 4.381-.01 16 10 .007.01-16zm-.999-2 12 .008a1 1 0 0 1 1 1l-.012 18a1 1 0 0 1-1.001 1l-12-.008a1 1 0 0 1-1-1.001l.013-18a1 1 0 0 1 1-1m5.99 15.004a1 1 0 1 1 0 2 1 1 0 0 1 0-2'
          fill='currentColor'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='currentColor' d='m.384.373 24 .016-.016 24-24-.016z' />
        </clipPath>
      </defs>
    </svg>
  );
}
